import { motion } from 'framer-motion';

export default function Mission() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-charcoal mb-4">
            Empower • Educate • Inspire
          </h2>
        </motion.div>

        {/* Mission Statement */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="max-w-4xl mx-auto text-center mb-20"
        >
          <p className="text-lg text-charcoal/80 leading-relaxed mb-6">
            At <strong className="text-charcoal">1 Heart Health & Wellness</strong>, we empower, educate, and inspire individuals to live healthier, more intentional lives through wellness education, community support, and compassionate care.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/about"
              className="bg-transparent border-2 border-charcoal text-charcoal px-6 py-2.5 rounded-full font-semibold hover:bg-charcoal hover:text-white transition-all whitespace-nowrap cursor-pointer text-sm"
            >
              Learn More About Our Mission
            </Link>
            <Link
              to="/programs"
              className="bg-transparent border-2 border-charcoal text-charcoal px-6 py-2.5 rounded-full font-semibold hover:bg-charcoal hover:text-white transition-all whitespace-nowrap cursor-pointer text-sm"
            >
              Explore Our Programs
            </Link>
          </div>
        </motion.div>

        {/* Visual Diagram */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="relative max-w-5xl mx-auto"
        >
          <img
            src="https://static.readdy.ai/image/56b439000ec6e974a9f2c259ba0dbcf0/c18385ad3af81802a669b910f071f40d.png"
            alt="The Crowned Life Co. - Our Programs Overview"
            className="w-full h-auto rounded-2xl shadow-2xl"
          />
        </motion.div>

        {/* Tagline */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="text-center mt-16"
        >
          <p className="font-serif text-2xl text-charcoal/70 italic">
            A Unified Mission: Wellness • Storytelling • Creativity • Community Impact
          </p>
        </motion.div>
      </div>
    </section>
  );
}

function Link({ to, className, children }: { to: string; className: string; children: React.ReactNode }) {
  return (
    <a href={to} className={className}>
      {children}
    </a>
  );
}
